<script setup lang="ts">
import { Accordion, AccordionItem } from "@frontiers-vue3/public-pages";
import FAQsList from "./RTOverviewFAQs.json";
import type { IRTOverviewFAQsList } from "./IRTOverviewFAQsList";

const sanitize = inject("sanitize") as (html: string) => string;
const terminology = useTerminologyStore();

const FAQs = computed((): IRTOverviewFAQsList[] => {
  const { domain } = useRuntimeConfig().public;
  const primaryJournal = useMain().primaryJournal;
  const FAQsItemsWithTerminology = JSON.stringify(FAQsList)
    .replace(/{{researchTopic}}/g, terminology.getTerm("researchTopic"))
    .replace(/{{primaryJournalSlug}}/g, String(primaryJournal?.slug))
    .replace(/{{domain}}/g, domain);

  const FAQsItems = JSON.parse(FAQsItemsWithTerminology);
  const FAQs: IRTOverviewFAQsList[] = [];
  FAQsItems.map((f: IRTOverviewFAQsList) => {
    FAQs.push(f);
  });
  return FAQs;
});
</script>
<template>
  <section id="FAQs">
    <h2 class="h2">Frequently asked questions</h2>
    <Accordion :auto-collapsable="false">
      <AccordionItem
        v-for="(item, index) in FAQs"
        :key="index"
        :title="item.title">
        <template #content>
          <div v-html="sanitize(item.content)"></div>
        </template>
      </AccordionItem>
    </Accordion>
  </section>
</template>
<style lang="scss">
#FAQs {
  .Accordion {
    border-top: 1px solid $grey50;

    &__item {
      background-color: $grey10;
      box-shadow: none;
      border-bottom: 1px solid $grey50;
      min-height: 69px;

      &__link {
        padding-left: 0;
      }
    }

    &__title {
      @include f-16-300;
      color: $textTertiary;
      padding-left: 0px;
      color: $black;
    }

    &__content {
      @include f-16-300;
      color: $textTertiary;

      & > div {
        padding: 8px 64px 16px 0;
      }

      a {
        @include ppLinkStyle;
      }
    }
  }
}
</style>
